/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {module_ as ɵangular_packages_upgrade_static_testing_testing_a} from '../../src/common/src/angular1';
export {INJECTOR_KEY as ɵangular_packages_upgrade_static_testing_testing_d,UPGRADE_APP_TYPE_KEY as ɵangular_packages_upgrade_static_testing_testing_b} from '../../src/common/src/constants';
export {UpgradeAppType as ɵangular_packages_upgrade_static_testing_testing_c} from '../../src/common/src/util';